import * as React from 'react';
import Styled from 'styled-components';

import { Headline, IHeadlineProps } from '../Typography/Headline';
import { media } from '../../lib/StyledComponents';

export const VerMasthead = Styled.div`
  margin: 0 0 1.5em;
  display: flex;

  ${media.medium`
    margin: 0 0 2em;
  `}
`;

VerMasthead.displayName = 'VerMasthead';

const MastHeadHeadline = Styled(Headline)<IHeadlineProps>`
  margin: 0 0 0.5em 0;
  color: ${({theme: { verifications } }) => verifications.mastHeadlineColor};
`;

interface IVerMastHeadHeadlineProps {
  // tslint:disable no-reserved-keywords no-any
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
}

export const VerMastHeadHeadline: React.FunctionComponent<
  React.HTMLAttributes<HTMLElement> & IVerMastHeadHeadlineProps
> = ({ children, ...rest }) => (
  <MastHeadHeadline
    as='h1'
    scale='large'
    {...rest}
  >
    {children}
  </MastHeadHeadline>
);

VerMastHeadHeadline.displayName = 'VerMastHeadHeadline';

// empty styled component for compatibility.
export const VerMastHeadIntro = Styled.div`
  display: block;
`;

VerMastHeadIntro.displayName = 'VerMastHeadIntro';

export const VerMastHeadPrimary = Styled.div`
  display: flex;
`;

VerMastHeadPrimary.displayName = 'VerMastHeadPrimary';

export const VerMastHeadSubhead = Styled.p`
  margin: 0;
`;

VerMastHeadSubhead.displayName = 'VerMastHeadSubhead';

export interface IVerMastHeadIcon {
  outset?: boolean;
}

export const VerMastHeadIcon = Styled.div<IVerMastHeadIcon>`
  display: none;
  color: ${({ theme: { taskCard} }) => taskCard.colorIcon};

  svg {
    width: 48px;
    height: 48px;
    fill: currentColor;
  }

  ${media.medium`
    display: block;
    margin-right: 1em;
  `}
`;

VerMastHeadIcon.defaultProps = {
  outset: false
};

VerMastHeadIcon.displayName = 'VerMastHeadIcon';

export default VerMasthead;
